import { render, staticRenderFns } from "./menuLink.vue?vue&type=template&id=24317331"
import script from "./menuLink.vue?vue&type=script&lang=js"
export * from "./menuLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports